import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useState, useEffect } from "react";
import { makeStyles, Typography } from "@material-ui/core";
import { ContainerSearch, ChatItem, InputSearch, DialogAddChatUser, Button } from "../../..";
import SearchIcon from "@material-ui/icons/Search";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
var useStyles = makeStyles(function (theme) {
  return {
    blockContainer: {
      padding: "20px"
    },
    titleContainer: {
      display: "flex",
      alignItems: "center",
      paddingBottom: "5px"
    },
    nameContainer: {
      flex: "1",
      "&:hover": {
        color: theme.palette.primary.main
      }
    },
    iconContainer: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    },
    icon: {
      marginLeft: "15px"
    },
    inputSearch: {
      borderRadius: "10px",
      border: "1px solid ".concat(theme.palette.primary.light),
      "box-shadow": "none",
      fontSize: "0.8em"
    },
    userNotFoundContainer: {
      paddingTop: "20px",
      display: "flex",
      flexDirection: "column",
      alignItems: "center"
    },
    startNewConversation: {
      margin: "10px 0"
    },
    searchContainer: {
      margin: "10px 0px",
      width: "95%"
    }
  };
});

var ChannelBlock = function ChannelBlock(props) {
  // console.log("ChannelBlock props", props);
  var search = props.search,
      add = props.add,
      data = props.data,
      blockType = props.blockType,
      handleClickItem = props.handleClickItem,
      translation = props.translation,
      users = props.users,
      startNewDirectMessage = props.startNewDirectMessage;
  var classes = useStyles();

  var _useState = useState(""),
      _useState2 = _slicedToArray(_useState, 2),
      searchValue = _useState2[0],
      setSearchValue = _useState2[1];

  var _useState3 = useState(""),
      _useState4 = _slicedToArray(_useState3, 2),
      _users = _useState4[0],
      set_Users = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      isSearchActive = _useState6[0],
      setIsSearchActive = _useState6[1];

  var _useState7 = useState(false),
      _useState8 = _slicedToArray(_useState7, 2),
      openDialogAddUser = _useState8[0],
      setOpenDialogAddUser = _useState8[1];

  var handleModalDialogAddUser = function handleModalDialogAddUser() {
    setOpenDialogAddUser(!openDialogAddUser);
  };

  var handleSearchChange = function handleSearchChange(event) {
    setSearchValue(event.target.value);
  };

  useEffect(function () {
    //TODO mejora->filter users si ya tienen direct_message
    users && set_Users(users.map(function (user) {
      return {
        label: user.name,
        value: user.rocket_chat.username
      };
    }));
  }, [users]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(DialogAddChatUser, {
    open: openDialogAddUser,
    searchValue: searchValue,
    onClose: handleModalDialogAddUser,
    selectUser: function selectUser(values) {
      // console.log("values ChannelBlock", values);
      var name = users.find(function (usr) {
        // console.log("usr", usr);
        return usr.rocket_chat.username === values.username;
      }).name; // console.log("name", name);

      startNewDirectMessage(values.username, name, "new");
    },
    users: _users,
    translation: translation && translation.dialogs ? translation.dialogs.new_conversation : null
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.blockContainer
  }, translation && translation.title && /*#__PURE__*/React.createElement("div", {
    className: classes.titleContainer
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6"
  }, translation && translation.title), /*#__PURE__*/React.createElement("div", {
    className: classes.iconContainer
  }, search && /*#__PURE__*/React.createElement(SearchIcon, {
    className: classes.icon,
    color: isSearchActive ? "white" : "primary",
    onClick: function onClick() {
      setSearchValue("");
      setIsSearchActive(!isSearchActive);
    }
  }), add && /*#__PURE__*/React.createElement(AddCircleOutlineIcon, {
    className: classes.icon,
    color: "primary",
    onClick: function onClick() {
      console.log("addd user");
      handleModalDialogAddUser();
    }
  }))), blockType === "general" ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ChatItem, {
    key: "announcements",
    name: translation.announcements,
    room: data.announcements.name,
    type: "group",
    handleClick: handleClickItem
  }), /*#__PURE__*/React.createElement(ChatItem, {
    key: "staff",
    name: translation.staff,
    room: data.staff.name,
    type: "group",
    handleClick: handleClickItem
  })) : /*#__PURE__*/React.createElement(React.Fragment, null, isSearchActive && /*#__PURE__*/React.createElement("div", {
    className: classes.searchContainer
  }, /*#__PURE__*/React.createElement(InputSearch, {
    value: searchValue,
    classes: classes.inputSearch,
    onChange: handleSearchChange,
    placeholder: translation ? translation.search_placeholder : "Search group",
    hideButton: true
  })), /*#__PURE__*/React.createElement(ContainerSearch, {
    search: searchValue,
    searchParam: "name",
    options: data,
    template: function template(option) {
      return /*#__PURE__*/React.createElement(ChatItem, {
        key: blockType === "direct" ? option.username : option.rocket_channel.name,
        name: option.name,
        room: blockType === "direct" ? option.username : option.rocket_channel.name,
        type: blockType,
        handleClick: props.handleClickItem,
        unread: option.unread,
        direct: blockType === "direct"
      });
    },
    notFound: function notFound() {
      return blockType === "direct" ? /*#__PURE__*/React.createElement("div", {
        className: classes.userNotFoundContainer
      }, /*#__PURE__*/React.createElement(Typography, {
        variant: "body1",
        align: "center"
      }, "No se han encontrado coincidencias."), /*#__PURE__*/React.createElement(Button, {
        variant: "outlined",
        color: "primary",
        onClick: handleModalDialogAddUser,
        className: classes.startNewConversation
      }, translation ? translation.buttons ? translation.buttons.select : "Start new conversation" : "Start new conversation")) : /*#__PURE__*/React.createElement(Typography, {
        variant: "body1",
        align: "center"
      }, "No se han encontrado coincidencias");
    },
    empty: function empty() {
      return blockType === "direct" ? /*#__PURE__*/React.createElement("div", {
        className: classes.userNotFoundContainer
      }, /*#__PURE__*/React.createElement(Typography, {
        variant: "body1",
        align: "center"
      }, "No tienes ninguna conversaci\xF3n abierta."), /*#__PURE__*/React.createElement(Button, {
        variant: "outlined",
        color: "primary",
        onClick: handleModalDialogAddUser,
        className: classes.startNewConversation
      }, translation ? translation.buttons ? translation.buttons.select : "Start new conversation" : "Start new conversation")) : /*#__PURE__*/React.createElement(Typography, {
        variant: "body1",
        align: "center"
      }, "Este servicio no tiene ning\xFAn grupo");
    }
  }))));
};

export { ChannelBlock };